<template>
	<Line :data="data" :options="options" />
</template>

<script>
import { Line } from 'vue-chartjs'
import { useChart } from '@/composables/useChart'

const LineChart = {
	props: ['data', 'options'],
	components: { Line },
	setup () {
		useChart()
	}
}

export default LineChart
export { LineChart as mdbLineChart }
</script>
